module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sms":"SMS","sendTo":"Отправить на","sendSMS":"Отправить SMS сообщение","send":"Отправить","cancel":"Отмена","messageSent":"Сообщение отправлено","length":"символов","smsLimitExceeded":"Превышено максимально допустимое количество в СМС","noPhoneNumber":"номер телефона не указан"}}')
  delete Component.options._Ctor
}
